import { render } from "./PopupWalletDeposit.vue?vue&type=template&id=6cd42405&scoped=true"
import script from "./PopupWalletDeposit.vue?vue&type=script&lang=js"
export * from "./PopupWalletDeposit.vue?vue&type=script&lang=js"

import "./PopupWalletDeposit.vue?vue&type=style&index=0&id=6cd42405&scoped=true&lang=scss"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd42405"]])

export default __exports__